var map = {
	"./mtn-za-cz/assets/game-logo.webp": 2685,
	"./mtn-za-lm/assets/game-logo.webp": 3467,
	"./mtn-za-mmr/assets/game-logo.webp": 4976,
	"./mtn-za-mr/assets/game-logo.webp": 991,
	"./mtn-za-rz/assets/game-logo.webp": 7810,
	"./mtn-za-uy/assets/game-logo.webp": 7764,
	"./mtn-za-yr/assets/game-logo.webp": 3147
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 501;